import { take, call, put, fork, cancel, cancelled, select } from 'redux-saga/effects'

import { loginResponse, loginError, LOGIN_REQUEST, LOGOUT } from './authActions'
import { getAuth } from './authReducer'
import config from '../utils/config'

export const sagas = {
    [LOGIN_REQUEST]: function* (action) {
        const { couchUrl } = config
        const { username, password } = action.payload
        try {            
            const session = yield call(fetch, `${couchUrl}/_session`,
                {
                    body: JSON.stringify({ name: username, password }),
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'content-type': 'application/json'
                    }
                })
            if (session.ok) {
                yield put(loginResponse(session.name, session.roles))
            } else if (!session.ok) {
                yield put(loginError(session.statusText))
            }
        } catch (_e) {
            yield put(loginError('Invalid user and/or password'))
        } finally {
            if (yield cancelled()) {
                yield put(loginError('Login cancelled'))
            }
        }
    },
    [LOGOUT]: function* () {
        const { couchUrl } = config
        yield call(fetchHelper, `${couchUrl}/_session`,
            {
                method: 'DELETE'
            })
    }
}

export default function* loginSaga() {
    while (true) {
        const action = yield take([LOGIN_REQUEST, LOGOUT])
        const auth = yield select(getAuth)
        if (action.type === LOGIN_REQUEST && !auth.isAuthenticated) {
            var loginTask = yield fork(sagas[LOGIN_REQUEST], action)
        } else if (action.type === LOGOUT) {
            if (typeof loginTask !== 'undefined') {
                yield cancel(loginTask)
            }
            yield call(sagas[LOGOUT], action)
        }
    }
}